export default __webpack_public_path__ + "img/pin_icons/fire_protection_b.png";